<template>
    <div  :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}" style="margin-top: 6px">
        <img src="@/assets/images/other-icons/low-priority.gif" v-if="priority === 1"/>
        <img src="@/assets/images/other-icons/medium-priority.gif" v-else-if="priority === 2"/>
        <img src="@/assets/images/other-icons/high-priority.gif" v-else-if="priority === 3"/>
    </div>
</template>

<script>
export default {
  name: 'CellRendererPriority',
  data(){
      return{
          priority : 0
      }
  },
  methods:{
      setPriority(params){
        this.priority = params.data.priority
      }
  },
  created(){
      this.setPriority(this.params);
  }
}
</script>